/**
 * A region that reloads in place (TMM-T4, TMMRSL-0068). While `busy` the content stays at full
 * contrast — it is never faded with opacity, which would escape the contrast audit — and an
 * indeterminate `LinearProgress` (`aria-hidden`) runs along the top of the region, which keeps
 * `aria-busy="true"` so assistive technology knows the content is being replaced.
 */
import { Box, LinearProgress, type BoxProps } from '@mui/material';

export interface BusyRegionProps extends BoxProps {
  busy: boolean;
}

export function BusyRegion({ busy, children, sx, ...rest }: BusyRegionProps) {
  return (
    <Box
      {...rest}
      aria-busy={busy ? 'true' : undefined}
      sx={[{ position: 'relative' }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {busy ? (
        <LinearProgress
          aria-hidden="true"
          sx={{ position: 'absolute', top: 0, insetInline: 0, height: 2, zIndex: 1 }}
        />
      ) : null}
      {children}
    </Box>
  );
}
